export default __webpack_public_path__ + "static/2-30c8ee7308bf816df896f955f20012e6.png";